import Main from '@/components/main';
import SeedFarmManagement from './seedFarm-management';

export default {
    path: '/seedFarm-management',
    name: 'seedFarm-management',
    meta: {
        icon: 'ios-apps',
        title: '苗场管理',
        showAlways: true
    },
    component: Main,
    children: [
        ...SeedFarmManagement
    ]
};
